import React from "react";
import { Card, CardContent } from "@/components/ui/card";

interface Props {
    message: string;
}

export const UserChatMessage = ({ message }: Props) => {
    return (
        <div className="ml-auto flex max-w-[80%] justify-end">
            <Card className="bg-blue-100 shadow">
                <CardContent className="p-4">{message}</CardContent>
            </Card>
        </div>
    );
};
